import * as React from 'react'
import Alert from '@mui/material/Alert'
import Stack from '@mui/material/Stack'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import * as component from './redux/componentRedux'
import {useEffect, useState} from 'react'

type AlertColor = 'success' | 'info' | 'warning' | 'error'

export const Alerts = () => {
  const [focus, setFocus] = useState(false)
  const [show, setShow] = useState(false)
  const [alertType, setAlertType] = useState<AlertColor>('success')
  const [alertMessage, setAlertMessage] = useState('')
  let timeout: any
  const reduxUserState = useSelector((state: RootState) => state.component)
  const alertState = reduxUserState.alert
  const dispatch = useDispatch()

  const handleFocus = () => {
    setFocus(true)
  }

  const handleUnFocus = () => {
    setFocus(false)
  }

  const handleClickAlert = () => {
    setShow(false)
    dispatch(
      component.actions.writeAlert({
        show: false,
        type: '',
        message: '',
      })
    )
  }

  useEffect(() => {
    if (alertState && alertState.show) {
      setShow(true)
      setAlertType(alertState.type)
      setAlertMessage(alertState.message)
    }
  }, [alertState])

  useEffect(() => {
    if (show && !focus) {
      let alert = {
        show: false,
        type: '',
        message: '',
      }
      timeout = setTimeout(() => {
        setShow(false)
        dispatch(component.actions.writeAlert(alert))
      }, 3000)
      return () => {
        clearTimeout(timeout)
      }
    } else {
      clearTimeout(timeout)
    }
  }, [show, focus])

  return (
    <div
      onClick={handleClickAlert}
      onMouseEnter={handleFocus}
      onMouseLeave={handleUnFocus}
      className={clsx('alert-custom', {show: show})}
    >
      <Stack onClick={handleClickAlert} sx={{width: '100%'}} spacing={2}>
        <Alert onClick={handleClickAlert} variant='filled' severity={alertType}>
          {alertMessage}
        </Alert>
      </Stack>
    </div>
  )
}
